class l{constructor(){this.handlerType="folder"}load(l,r){r(null,null)}open(l,r){return r}}export{l as FolderHandler};
